export default __webpack_public_path__ + "static/media/portrait10.79a5974a.jpeg";